import { message } from 'antd';
import { useEffect, useState } from 'react';
import { useBusinessUpdate } from './useBusinessUpdate';
import { BusinessUpdateBody } from '../../../../store/business/update';
import { getAddressComponent } from '../../ShareYourTwoCents/CreateNewPost';
import { useGoogleMapsContext } from '../../../../GoogleMapsProvider';

export const useSyncWithGoogle = () => {
  const { updateBusiness, loading: updateBusinessLoading, response } = useBusinessUpdate();
  const { isLoaded } = useGoogleMapsContext();

  const [loading, setLoading] = useState(false);

  const syncWithGoogle = ({ placeId, businessId }: { placeId: string, businessId: string }) => {
    if (!isLoaded) {
      message.warning('Google services are still loading. Please try again in a moment.');

      return;
    }

    setLoading(true);
    const service: google.maps.places.PlacesService = new google.maps.places.PlacesService(
      document.createElement('div'),
    );

    service.getDetails(
      { placeId },
      (place, status) => {
        if (status === 'OK' && place) {
          const businessUpdateBody: BusinessUpdateBody = {
            name: place?.name || '',
            city: getAddressComponent(place, 'locality'),
            state: getAddressComponent(place, 'administrative_area_level_1'),
            country: getAddressComponent(place, 'country'),
            zipCode: getAddressComponent(place, 'postal_code'),
            phone: place?.international_phone_number || '',
            website: place?.website || '',
            googleMapsInfo: {
              placeId: place?.place_id || '',
              address: place?.formatted_address || '',
              website: place?.website || '',
              url: place?.url || '',
              phoneNumber: place?.international_phone_number || '',
              fileUrls: place?.photos?.map((photo) => photo.getUrl()) || [],
              openingHoursWeekdayText:
              // @ts-ignore ignore missing val
                place?.current_opening_hours?.weekday_text || [],
            },
          };

          updateBusiness({ id: businessId, body: businessUpdateBody });
        } else {
          setLoading(false);
          message.error(
            'Error reading business information from Google Places',
          );
        }
      },
    );
  };

  useEffect(() => {
    if (response) {
      setLoading(false);
    }
  }, [response]);

  return {
    syncWithGoogle, loading, response, isLoaded,
  };
};

export default useSyncWithGoogle;
